// Common Problems cards. `value` maps 1:1 to the tree's `symptom` node
// options — clicking a card answers that node and enters the wizard.
export interface ProblemCard {
    value: string
    label: string
    emoji: string
    blurb: string
}

export const PROBLEMS: ProblemCard[] = [
    { value: 'ac_not_cooling', label: 'AC Not Cooling', emoji: '🥵', blurb: 'Running but the house stays warm' },
    { value: 'warm_air', label: 'Blowing Warm Air', emoji: '♨️', blurb: 'Vents push air that is not cold' },
    { value: 'frozen_coil', label: 'Frozen Coil / Ice', emoji: '🧊', blurb: 'Ice on the lines or indoor coil' },
    { value: 'water_leak', label: 'Water Leak', emoji: '💧', blurb: 'Water where it should not be' },
    { value: 'loud_noise', label: 'Loud Noise', emoji: '🔊', blurb: 'Grinding, squealing, or banging' },
    { value: 'weak_airflow', label: 'Weak Airflow', emoji: '🌬️', blurb: 'Barely anything from the vents' },
    { value: 'high_bill', label: 'High Electric Bill', emoji: '⚡', blurb: 'Costs jumped without explanation' },
    { value: 'thermostat', label: 'Thermostat Problems', emoji: '🌡️', blurb: 'Blank, wrong, or unresponsive' },
    { value: 'heat_pump', label: 'Heat Pump Issues', emoji: '🔁', blurb: 'Heating or cooling misbehaving' },
    { value: 'furnace', label: 'Furnace Problems', emoji: '🔥', blurb: 'No heat, short cycling, smells' },
    { value: 'other', label: 'Something Else', emoji: '❓', blurb: 'Describe it and we will help' },
]
